module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba-funabashi-point2-2@2x-e42d01b1cc87e3c151bd8abc3bd50d5e.webp";